export const modalmultiData = {
    "titulo":"Convocatorias",
    "imagen1":"https://s-seguridad.hidalgo.gob.mx/assets/imgs/procesal202608.jpeg",
    "imagen2":"https://s-seguridad.hidalgo.gob.mx/assets/imgs/penitenciario202608.jpeg",
    "link1":"https://s-seguridad.hidalgo.gob.mx/assets/pdf/procesal202608.pdf",
    "link2":"https://s-seguridad.hidalgo.gob.mx/assets/pdf/penitenciario202608.pdf"
}
    